module.exports = __webpack_public_path__ + "img/sub3.95a63c0b.png";